import api from "./api";

// Activity feed for one actor (technician) within the last `days` days.
// Used by the technician status drawer (Last 24 Hours / 7 / 30 Days).
const getActorFeed = (actorId, days) => {
  return api.get("/api/activity-log/get_actor_feed", {
    params: { actorId, days },
  });
};

const ActivityLogService = {
  getActorFeed,
};

export default ActivityLogService;
